import React from 'react';
import I18n from 'i18n-js';
import {
  IAdminAccommodationReason,
  IRefundState,
} from './refund_request';

import ReverbAccommodationCheckbox, { AdyenPayoutsBlockedWarning } from './reverb_accommodation_checkbox';
import AdminAccommodationReasonDropdown from './admin_accommodation_reason_dropdown';

interface IProps {
  accommodationAuthorized?: boolean;
  isAdyenShopWithPayoutsDisabled?: boolean;
  isReverbAccommodated: boolean;
  toggleReverbAccommodated: (event: any) => void;
  adminAccommodationReason: IAdminAccommodationReason;
  onAdminAccommodationReasonChange: (event: any) => void;
  refundState: IRefundState;
}

export default function AdminFormFields(props: IProps) {

  return (
    <div className="scaling-mtb-4">
      <div className="form-group">
        <div className="form-group__header">
          <label className="form-group__label-text">
            {I18n.t('discovery.dashboard.refundRequests.admin.formFields.title')}
          </label>
        </div>
        <div className="form-group__fields">
          {renderReverbAccommodationCheckbox(props)}
          {renderAdminAccommodationReasonDropdown(props)}
        </div>
      </div>
    </div>
  );
}

const renderReverbAccommodationCheckbox = (props: IProps) => {
  const {
    accommodationAuthorized,
    isAdyenShopWithPayoutsDisabled,
  } = props;

  if (accommodationAuthorized && !isAdyenShopWithPayoutsDisabled) {
    return ReverbAccommodationCheckbox(props);
  }

  if (accommodationAuthorized && isAdyenShopWithPayoutsDisabled) {
    return AdyenPayoutsBlockedWarning();
  }

  return null;
};

const renderAdminAccommodationReasonDropdown = (props: IProps) => {
  const {
    refundState,
    isReverbAccommodated,
    adminAccommodationReason,
    onAdminAccommodationReasonChange,
  } = props;

  const approved = refundState === IRefundState.APPROVED;

  if (isReverbAccommodated && approved) {

    return (
      <AdminAccommodationReasonDropdown
        adminAccommodationReason={adminAccommodationReason}
        onAdminAccommodationReasonChange={onAdminAccommodationReasonChange}
      />
    );
  }

  return null;
};
